/**
 * Join class names, dropping the ones that are not there.
 *
 * That is all a class helper has to do here. The kit's rules are in
 * `@layer components` and Tailwind's utilities are in a later layer, so a
 * utility passed in `className` always wins — there is no conflict for a
 * merging library to resolve.
 */
export type ClassValue = string | false | null | undefined;

export function cx(...parts: ClassValue[]): string {
  let out = "";
  for (const part of parts) {
    if (!part) continue;
    out = out ? `${out} ${part}` : part;
  }
  return out;
}
